module.exports = __webpack_public_path__ + "1e8d802f6534fca7249fd6f409219f1c.svg";